import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import Notification from "../page";

const routes: AppRouteType[] = [
  {
    path: slugs.notification,
    component: Notification,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
